'use client'

import { useEffect } from 'react'

import { useAppRouter } from '@/shared/lib/router'

import { useQueryClient } from '@tanstack/react-query'

const ROUTES = [
  '/',
  '/missoes',
  '/ranking',
  '/loja',
  '/biblioteca',
  '/central-de-ajuda'
] as const

const PREFETCH_QUERY_KEYS: [string, unknown][] = [
  ['/user/rankings', undefined],
  ['/user/reward_categories', undefined],
  ['/user/campaigns', undefined]
]

function runPrefetch(
  router: ReturnType<typeof useAppRouter>,
  queryClient: ReturnType<typeof useQueryClient>
) {
  ROUTES.forEach(route => router.prefetch(route))
  PREFETCH_QUERY_KEYS.forEach(([path, params]) => {
    queryClient.prefetchQuery({ queryKey: [path, params] })
  })
}

export function GlobalPrefetch() {
  const router = useAppRouter()
  const queryClient = useQueryClient()

  useEffect(() => {
    const id = typeof requestIdleCallback !== 'undefined'
      ? requestIdleCallback(() => runPrefetch(router, queryClient), { timeout: 3000 })
      : setTimeout(() => runPrefetch(router, queryClient), 0) as unknown as number

    return () => {
      if (typeof cancelIdleCallback !== 'undefined') {
        cancelIdleCallback(id as ReturnType<typeof requestIdleCallback>)
      } else {
        clearTimeout(id)
      }
    }
  }, [router, queryClient])

  return null
}
